var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCadastros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24.306,
    stroke: "#3C3C3B",
    strokeWidth: 2,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.167,
    height: 1.736,
    x: 5.833,
    y: 6.944,
    fill: "#3C3C3B",
    rx: 0.868
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.167,
    height: 1.736,
    x: 5.833,
    y: 11.285,
    fill: "#3C3C3B",
    rx: 0.868
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.167,
    height: 1.736,
    x: 5.833,
    y: 15.625,
    fill: "#3C3C3B",
    rx: 0.868
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCadastros);
export default __webpack_public_path__ + "static/media/icon_cadastros.8824bf7932896ed754ce4950bc3e2b94.svg";
export { ForwardRef as ReactComponent };